import React from "react";
import GlobalList from "../../Components/Lists/GlobalList";
import styles from "../style/BookingOverview.module.css";
import { availableItemFieldsForListBooking } from "../BookkeepingConfig";
import BookkeepingToolBar from "../BookkeepingToolBar";
import Localize from "react-intl-universal";

const BookingMiddlePanel = props => {
  const {
    currentView,
    listState,
    searchFilter,
    filterObject,
    forbidenResponse,
    selectedItem,
    setSelectedItem,
    paginationStatus,
    activePaginationPage,
    searchObject,
    handlePageChange
  } = props;

  const myToolbarSearch = (e, data) => {
    e.preventDefault();
    searchFilter(e, data, searchObject);
  };

  const actionOptions = [
    {
      name: "printPreview",
      text: Localize.get("BOOKKEEPING.PRINT_VIEW"),
      icon: "file outline"
    },
    {
      name: "exportAcconts",
      text: Localize.get("BOOKKEEPING.FIX"),
      icon: "briefcase"
    }
  ];

  const resetSearchIputField = (event, data) => {
    searchFilter(event, { ...data, name: "search", value: "" }, searchObject);
  };

  return (
    <>
      <BookkeepingToolBar
        searchName={myToolbarSearch}
        enteredValue={searchObject.search}
        resetNameSearch={resetSearchIputField}
        actionOptions={actionOptions}
      />

      <GlobalList
        currentView={currentView}
        listState={listState}
        searchFilter={searchFilter}
        filterObject={filterObject}
        forbidenResponse={forbidenResponse}
        availableItemFieldsForList={availableItemFieldsForListBooking}
        selectedItem={selectedItem}
        setSelectedItem={setSelectedItem}
        paginationStatus={paginationStatus}
        handlePageChange={handlePageChange}
        activePaginationPage={activePaginationPage}
        listPaginationCustomCSS={
          paginationStatus.pageCount > 1 ? styles.middle_panel_list : styles.middle_panel_list_0
        }
        showAtBottom={true}
      />
    </>
  );
};

export default BookingMiddlePanel;
